import { vuex_subscribe_module, vuex_store_config } from '@/vuex'
import { load_state_from_local_storage } from '@/resources'

const vuex_config_object = {
}

export const serialized_vuex_config_object = JSON.stringify(vuex_config_object)

const state_config = vuex_store_config(vuex_config_object)

let name = 'travelc',
  state = state_config.state,
  module = {
    namespaced: true,
    state: load_state_from_local_storage(name, state_config.state),
    mutations: {
      ...state_config.mutations,
    },
    getters: state_config.getters,
    actions: state_config.actions,
    get_local_storage_submodule() {
      // dichiaro le chiavi che verranno scritte nel local storage
      return {
      }
    },
  }

export function register_state_module(prototype) {
  if (prototype.$submodules == undefined) prototype.$submodules = {}
  prototype.$submodules[name] = {
    get_local_storage_submodule: module.get_local_storage_submodule()
  }
  vuex_subscribe_module(name, state, module)
}